import APIContext from 'contexts/base/APIContext'

export default class AssetsTendersContext extends APIContext{
  static contextName = 'assetsTenders'
}
